import { RemovePageButton } from './RemovePageButton';

interface FunnelPageEditorHeaderProps {
    title: string;
    description: string;
    onRemove: () => void;
    canRemove?: boolean;
}

export const FunnelPageEditorHeader = ({
    title,
    description,
    onRemove,
    canRemove = true,
}: FunnelPageEditorHeaderProps) => (
    <div className='flex items-start justify-between gap-4'>
        <div className='flex flex-col gap-2'>
            <h2 className='text-heading-h3 text-dark md:text-heading-h2!'>{title}</h2>
            <p className='text-body-sm text-gray md:text-body-md'>{description}</p>
        </div>
        {canRemove && <RemovePageButton onClick={onRemove} />}
    </div>
);
